import { useState, useRef, useEffect } from "react";
import { IconBell } from "@tabler/icons-react";
import { useNotificationContext } from "@/contexts/NotificationContext";
import { NotificationPanel } from "./NotificationPanel";

export function NotificationBell() {
	const { unreadCount, fetchNotifications } = useNotificationContext();
	const [open, setOpen] = useState(false);
	const panelRef = useRef<HTMLDivElement>(null);
	const bellRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		function handleClickOutside(e: MouseEvent) {
			if (
				panelRef.current &&
				!panelRef.current.contains(e.target as Node) &&
				bellRef.current &&
				!bellRef.current.contains(e.target as Node)
			) {
				setOpen(false);
			}
		}
		if (open) {
			document.addEventListener("mousedown", handleClickOutside);
			return () => document.removeEventListener("mousedown", handleClickOutside);
		}
	}, [open]);

	const toggle = () => {
		setOpen((o) => !o);
	};

	useEffect(() => {
		if (open) {
			fetchNotifications();
		}
	}, [open, fetchNotifications]);

	return (
		<div className="relative">
			<button
				ref={bellRef}
				type="button"
				onClick={toggle}
			aria-label="Notifikasi"
			aria-expanded={open}
			className="relative flex items-center justify-center p-1 cursor-pointer border-none bg-transparent"
				style={{ color: "var(--color-text)" }}
			>
				<IconBell size={20} />
				{unreadCount > 0 && (
					<span className="absolute -top-0.5 -right-0.5 flex items-center justify-center rounded-full text-white text-[0.65rem] font-bold leading-none" style={{ width: 16, height: 16, background: "var(--color-primary)" }}>
						{unreadCount > 99 ? "99+" : unreadCount}
					</span>
				)}
			</button>
			{open && (
				<div ref={panelRef} className="absolute right-0 top-full mt-2 z-50 notification-panel-wrapper">
					<NotificationPanel />
				</div>
			)}
		</div>
	);
}
